module.exports = __webpack_public_path__ + "img/129.0f6c2c94.jpg";